export default __webpack_public_path__ + "static/media/gold-category-icon.dc32ddd3.svg";